module.exports = __webpack_public_path__ + "static/media/Room2.b215f040.PNG";